import * as React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { PersistGate } from 'redux-persist/integration/react'
import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { persistor, store } from './store';
import AppRouter from './Route/AppRouter';
import CookieConsent from './Components/CookieConsent/CookieConsent';
import Loading from './Components/LoadingComponent';
import queryClient from './lib/queryClient';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';

const theme = createTheme({
  palette: {
    primary: {
      main: '#454545'
    },
    secondary: {
      main: '#eb4034'
    }
  }
});

function App() {
  return(
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <PersistGate loading={<Loading />} persistor={persistor}>
          <ThemeProvider theme={theme}>
            <AppRouter />
            <CookieConsent />
          </ThemeProvider>
        </PersistGate>
      </QueryClientProvider>
    </Provider>
  )
}

export default App;
